"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormularioAlumni = void 0;
var React = require("react");
var sweetalert2_1 = require("sweetalert2");
var reactstrap_1 = require("reactstrap");
var LoginRedes_js_1 = require("./LoginRedes.js");
var verificacion_cedula_js_1 = require("./utils/verificacion_cedula.js");
//import { ReactComponent as Banner } from '../assets/img/BannerSeguimiento.svg';
var Banner = require("../assets/img/BannerSeguimientoPng.png");
console.log(Banner);
var InformacionPersonal_1 = require("./secciones/InformacionPersonal");
var InformacionLaboral_1 = require("./secciones/InformacionLaboral");
var InformacionLaboralParte2_1 = require("./secciones/InformacionLaboralParte2");
var InformacionEmprendimiento_1 = require("./secciones/InformacionEmprendimiento");
var InformacionImpacto_1 = require("./secciones/InformacionImpacto");
var InformacionAcademica_1 = require("./secciones/InformacionAcademica");
var InformacionInteres_1 = require("./secciones/InformacionInteres");
require("../assets/css/formulario.css");
var Clases = require("../clases_comunes");
var OpcionesList = require("../opciones.js");
var SERVER_URL = process.env.REACT_APP_SERVER_URL;
var FormularioAlumni = /** @class */ (function (_super) {
    __extends(FormularioAlumni, _super);
    function FormularioAlumni(props) {
        var _this = _super.call(this, props) || this;
        _this.abortController = new window.AbortController();
        _this.state = {
            loading: true, error: null,
            identificacion: "", dia: "", mes: "", anio: "", idpersona: 0, tieneDatosPost: false, graduadoPost: false,
            paisesList: [], paisesSelectList: [], paisFonoSelectList: [], provinciasList: [], provinciasSelectList: [],
            ciudadesList: [], ciudadesSelectList: [], parroquiasList: [], parroquiasSelectList: [],
            universidadList: [], universidadSelectList: [], sectorListSelect: [],
            //datosalumni: new Clases.DatosAlumni(), infopersonal: new Clases.InfoPersonal(), infolaboral: new Clases.InfoLaboral(), infoacademica: new Clases.InfoAcademica(), infoimpacto: new Clases.ImpactoPostgrados(),
            datosalumni: null, infopersonal: null, infolaboral: null, infoacademica: null, infoimpacto: null,
            telecasaalum: new Clases.TblTelefonoInfo(), telecelalum: new Clases.TblTelefonoInfo(),
            tipoFonoSelect: "",
            cedulaModal: true, modalEnd: false, alertCargando: false, alertExito: false, alertError: false,
            graduadode: [], progressValue: 0,
            loginOpen: true, redSocial: "", emailRedsocial: "", opcionesPrimerTrabajo: [], opcionesInteres: [],
            opcionesEstudAdic: [], opcionesMejorCondicion: [], encuestaActiva: false, cohortesObjetivo: []
        };
        // METODOS
        _this.exceptionsInput = _this.exceptionsInput.bind(_this);
        _this.exceptionsTextInput = _this.exceptionsTextInput.bind(_this);
        _this.validarCambiosSeccion = _this.validarCambiosSeccion.bind(_this);
        _this.retrocederSeccion = _this.retrocederSeccion.bind(_this);
        _this.resetFormulario = _this.resetFormulario.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.closeLoginRedes = _this.closeLoginRedes.bind(_this);
        _this.closeLoginEspol = _this.closeLoginEspol.bind(_this);
        _this.closeVerificacionCedula = _this.closeVerificacionCedula.bind(_this);
        return _this;
    }
    FormularioAlumni.prototype.componentDidMount = function () {
        this.initializeTelefonos();
        this.cargarDatos();
    };
    FormularioAlumni.prototype.componentWillUnmount = function () {
        this.abortController.abort();
    };
    /**
     * Asigna el tipo de telefono a los objetos telefono
     * */
    FormularioAlumni.prototype.initializeTelefonos = function () {
        var telecasaalum = this.state.telecasaalum;
        var telecelalum = this.state.telecelalum;
        telecasaalum.tipotelefono = "D";
        telecelalum.tipotelefono = "C";
        this.setState({ telecasaalum: telecasaalum, telecelalum: telecelalum });
    };
    /**
     * Carga la informacion necesaria para los select
     * */
    FormularioAlumni.prototype.cargarDatos = function () {
        var _this = this;
        // PAISES
        fetch('https://ws.espol.edu.ec/rest/api/pais', { signal: this.abortController.signal })
            .then(function (response) { return response.json(); })
            .then(function (data) {
            var paisesList = data.sort(function (a, b) { return a.strNombre > b.strNombre ? 1 : -1; })
                .map(function (p) { return ({
                "value": p.siIdPais,
                "label": p.strNombre.trim(),
                "link": p.siIdPais
            }); });
            var paisesFono = data.filter(function (p) { return p.strCodigoTelefonico !== null; })
                .sort(function (a, b) { return a.strNombre > b.strNombre ? 1 : -1; })
                .map(function (p) { return ({
                "value": p.siIdPais,
                "label": p.strNombre.trim() + " - " + p.strCodigoTelefonico.trim(),
                "link": p.strCodigoTelefonico.trim()
            }); });
            _this.setState({ paisesList: data, paisesSelectList: paisesList, paisFonoSelectList: paisesFono });
        }, function (error) {
            if (error.name === "AbortError") {
                console.log("AbortError controlado");
            }
            else {
                _this.setState({
                    loading: false,
                    error: error,
                    paisesList: [], paisesSelectList: []
                });
                console.log("Ocurrió un error al obtener los paises: " + error);
            }
        });
        // PROVINCIAS
        fetch('https://ws.espol.edu.ec/rest/api/provincia', { signal: this.abortController.signal })
            .then(function (response) { return response.json(); })
            .then(function (data) {
            var provList = data.sort(function (a, b) { return a.strNombreProvincia > b.strNombreProvincia ? 1 : -1; })
                .map(function (p) { return ({
                "value": p.siIdProvincia,
                "label": p.strNombreProvincia.trim(),
                "link": p.siIdPais,
                "linkciud": p.siIdProvincia
            }); });
            _this.setState({ provinciasList: data, provinciasSelectList: provList });
        }, function (error) {
            if (error.name === "AbortError") {
                console.log("AbortError controlado");
            }
            else {
                _this.setState({
                    loading: false,
                    error: error,
                    provinciasList: [], provinciasSelectList: []
                });
                console.log("Ocurrió un error al obtener las provincias: " + error);
            }
        });
        // CANTONES
        fetch('https://ws.espol.edu.ec/rest/api/canton', { signal: this.abortController.signal })
            .then(function (response) { return response.json(); })
            .then(function (data) {
            var ciudList = data.sort(function (a, b) { return a.strNombreCanton > b.strNombreCanton ? 1 : -1; })
                .map(function (c) { return ({
                "value": c.siIdCanton,
                "label": c.strNombreCanton.trim(),
                "link": c.siIdProvincia
            }); });
            _this.setState({ ciudadesList: data, ciudadesSelectList: ciudList });
        }, function (error) {
            if (error.name === "AbortError") {
                console.log("AbortError controlado");
            }
            else {
                _this.setState({
                    loading: false,
                    error: error,
                    ciudadesList: [], ciudadesSelectList: []
                });
                console.log("Ocurrió un error al obtener los cantones: " + error);
            }
        });
        // PARROQUIAS
        fetch('https://ws.espol.edu.ec/rest/api/parroquia', { signal: this.abortController.signal })
            .then(function (response) { return response.json(); })
            .then(function (data) {
            var parroquiasList = data.sort(function (a, b) { return a.strNombreParroquia > b.strNombreParroquia ? 1 : -1; })
                .map(function (p) { return ({
                "value": p.intIdParroquia,
                "label": p.strNombreParroquia.trim(),
                "link": p.siIdCanton
            }); });
            _this.setState({ parroquiasList: data, parroquiasSelectList: parroquiasList });
        }, function (error) {
            if (error.name === "AbortError") {
                console.log("AbortError controlado");
            }
            else {
                _this.setState({
                    loading: false,
                    error: error,
                    parroquiasList: [], parroquiasSelectList: []
                });
                console.log("Ocurrió un error al obtener las parroquias: " + error);
            }
        });
        // SECTORES DE EMPRESAS
        fetch(SERVER_URL + "Informacion/GetSectoresEmpresa", { signal: this.abortController.signal })
            .then(function (response) { return response.json(); })
            .then(function (data) {
            var sectores = data.map(function (s) { return ({
                "value": s.idsectorempresa,
                "label": s.nombre.trim()
            }); });
            _this.setState({ sectorListSelect: sectores });
        }, function (error) {
            if (error.name === "AbortError") {
                console.log("AbortError controlado");
            }
            else {
                _this.setState({
                    loading: false,
                    error: error,
                    sectorListSelect: []
                });
                console.log("Ocurrió un error al obtener los sectores: " + error);
            }
        });
        // UNIVERSIDADES ECUADOR
        fetch(SERVER_URL + "Informacion/GetUniversidadesEC", { signal: this.abortController.signal })
            .then(function (response) { return response.json(); })
            .then(function (data) {
            var universidades = data.sort(function (a, b) { return a.nombre > b.nombre ? 1 : -1; })
                .map(function (u) { return ({
                "value": u.idinstitucion,
                "label": u.nombre
            }); });
            _this.setState({ universidadList: data, universidadSelectList: universidades });
        }, function (error) {
            if (error.name === "AbortError") {
                console.log("AbortError controlado");
            }
            else {
                _this.setState({
                    loading: false,
                    error: error,
                    universidadList: [], universidadSelectList: []
                });
                console.log("Ocurrió un error al obtener las universidades: " + error);
            }
        });
        // PERIODO ENCUESTA
        fetch(SERVER_URL + "Informacion/GetPeriodoEncuesta", { signal: this.abortController.signal })
            .then(function (response) { return response.json(); })
            .then(function (responsejson) {
            console.log("periodoEncuesta: ", responsejson);
            if (responsejson.status.isSuccessfully) {
                _this.setState({
                    encuestaActiva: responsejson.data.estaactivo,
                    cohortesObjetivo: responsejson.data.cohortes
                });
            }
        }, function (error) {
            if (error.name === "AbortError") {
                console.log("AbortError controlado");
            }
            else {
                _this.setState({
                    loading: false,
                    error: error,
                    encuestaActiva: false, cohortesObjetivo: []
                });
                console.log("Ocurrió un error al obtener el periodo de encuesta: " + error);
            }
        });
    };
    FormularioAlumni.prototype.getAllInformation = function (numeroIdentificacion) {
        var _this = this;
        fetch("api/InformacionPostgrado/GetAllPersonaSTAC/" + this.state.identificacion, { signal: this.abortController.signal })
            .then(function (response) { return response.json(); })
            .then(function (responsejson) {
            if (responsejson["strEstado"] === "N") {
                var mensaje = "No pertenece al grupo de alumni.";
                sweetalert2_1.default.fire({
                    title: '¡Oh no!',
                    text: 'No pertenece al grupo de alumni.',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then(function (result) {
                    if (result.isConfirmed) {
                        sweetalert2_1.default.close();
                    }
                });
            }
            else if (responsejson["strEstado"] === "I") {
                console.log("Ocurrió un error en GetAllPersonaSTAC.");
                sweetalert2_1.default.fire({
                    title: '¡Oh no!',
                    text: 'Se ha producido un error al momento de obtener su información',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then(function (result) {
                    if (result.isConfirmed) {
                        sweetalert2_1.default.close();
                    }
                });
            }
            else {
                //console.log("getAllInformation responsejson: ", responsejson);
                var idpersonaRJ = responsejson["tnumero"];
                var datosalumni1 = responsejson["tdatosalumni"];
                var datospostgrados = responsejson["tdatospostgrados"];
                var datospersonal = responsejson["tinfopersonal"];
                var datosacademica = responsejson["tinfoacademica"];
                var datoslaboral = responsejson["tinfolaboral"];
                var datosimpacto = responsejson["tinfoimpacto"];
                var datostelefono = responsejson["ttelefonos"];
                var tieneTituloSenescyt = responsejson["tieneTituloSenescyt"];
                var datosTituloSenescyt = responsejson["tituloSenescyt"];
                _this.showDatosAlumni(idpersonaRJ, datosalumni1, datospostgrados, datospersonal, datosacademica, datoslaboral, datosimpacto, datostelefono, tieneTituloSenescyt, datosTituloSenescyt);
            }
        });
    };
    FormularioAlumni.prototype.closeLoginRedes = function (redSocial, emailUser) {
        var _this = this;
        fetch(SERVER_URL + "Informacion/GetSocialLogin/".concat(emailUser, "&").concat(redSocial), { signal: this.abortController.signal })
            .then(function (response) { return response.json(); })
            .then(function (responseJsonSocial) {
            //console.log("GetSocialLogin: ", responseJsonSocial);
            if (responseJsonSocial.status.isSuccessfully) {
                var numeroIdentificacion = responseJsonSocial.data.tidentificacion;
                _this.setState({ redSocial: redSocial, emailRedsocial: emailUser, identificacion: numeroIdentificacion }, function () {
                    _this.getAllInformation(_this.state.identificacion);
                });
            }
            else {
                sweetalert2_1.default.close();
                console.log("No tiene información de inicio de sesión.");
                _this.setState({ loginOpen: false, redSocial: redSocial, emailRedsocial: emailUser });
            }
        }, function (error) {
            if (error.name === "AbortError") {
                console.log("AbortError controlado");
            }
            else {
                var mensaje = "Ocurrió un error al obtener información de inicio de sesión.";
                console.log("Ocurrió un error en GetInformacionInteres: " + error);
                sweetalert2_1.default.fire({
                    title: '¡Oh no!',
                    text: 'Se ha producido un error al momento de obtener su información de inicio de sesión',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then(function (result) {
                    if (result.isConfirmed) {
                        sweetalert2_1.default.close();
                    }
                });
            }
        });
    };
    FormularioAlumni.prototype.closeLoginEspol = function (numeroIdentificacion) {
        var _this = this;
        this.setState({ identificacion: numeroIdentificacion }, function () {
            _this.getAllInformation(_this.state.identificacion);
        });
    };
    FormularioAlumni.prototype.closeVerificacionCedula = function (idpersonaRJ, datosalumni1, datospostgrados) {
        var _this = this;
        var numIdentificacion = datosalumni1.numeroidentificacion;
        var objetoLogin = new Clases.InfoLogin();
        objetoLogin.email = this.state.emailRedsocial;
        objetoLogin.idpersona = idpersonaRJ;
        objetoLogin.tipoalumni = (datospostgrados !== null && datospostgrados.item !== null &&
            datospostgrados.item.lPostgradosGraduados !== null && datospostgrados.item.lPostgradosGraduados.length > 0) ? "P" : "G";
        objetoLogin.tiporedsocial = this.state.redSocial;
        var datosRedes = JSON.stringify({ "objeto": objetoLogin });
        fetch(SERVER_URL + "Formulario/PostDatosLogin", {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: datosRedes
        })
            .then(function (response) { return response.json(); })
            .then(function (responsePost) {
            //console.log("PostDatosLogin: ", responsePost);
            if (responsePost.status.isSuccessfully) {
                // OBTENIENDO ALL INFORMATION
                fetch(SERVER_URL + "Informacion/GetAllInformation/" + idpersonaRJ + "/" + numIdentificacion, { signal: _this.abortController.signal })
                    .then(function (response) { return response.json(); })
                    .then(function (responsejson) {
                    //console.log("GetAllInformation: ", responsejson);
                    if (responsejson.status.isSuccessfully) {
                        // INFORMACION PERSONAL
                        // ACTUALIZANDO EMAIL ALTERNO
                        if (_this.state.redSocial !== "" && _this.state.redSocial !== "I") {
                            responsejson.data.tinfopersonal.emailalterno = _this.state.emailRedsocial;
                        }
                        // INFORMACION ACADEMICA
                        var infoacaid;
                        if (responsejson.data.tinfoacademica !== null) {
                            infoacaid = responsejson.data.tinfoacademica;
                        }
                        else {
                            infoacaid = new Clases.InfoAcademica();
                            infoacaid.idpersona = idpersonaRJ;
                            infoacaid.fechagraduacion = null;
                        }
                        var tieneDatosGrado = false;
                        var tieneDatosPost = false;
                        var graduadoPost = false;
                        var carrerasgraduado = Array();
                        var fechaGraduacion = new Date();
                        // agregando carrera de grado
                        if (datosalumni1 !== null && datosalumni1.nombrecarrera !== null) {
                            infoacaid["tipoalumni"] = "G";
                            infoacaid["carreraalumni"] = datosalumni1.nombrecarrera;
                            infoacaid["fechagraduacion"] = datosalumni1.fechagraduacion;
                            carrerasgraduado.push(datosalumni1.nombrecarrera.toUpperCase());
                            fechaGraduacion = new Date(datosalumni1.fechagraduacion);
                            tieneDatosGrado = true;
                        }
                        if (datospostgrados !== null && datospostgrados.item !== null) {
                            if (datospostgrados.item.lPostgradosGraduados !== null && datospostgrados.item.lPostgradosGraduados.length > 0) {
                                var itemGradLength = datospostgrados.item.lPostgradosGraduados.length;
                                var carreraGradNAame = datospostgrados.item.lPostgradosGraduados[itemGradLength - 1];
                                graduadoPost = true;
                                infoacaid["tipoalumni"] = "P";
                                infoacaid["carreraalumni"] = carreraGradNAame.nombrePrograma;
                                infoacaid["fechagraduacion"] = carreraGradNAame.fechaGraduacion;
                                fechaGraduacion = new Date(carreraGradNAame.fechaGraduacion);
                                var modalidadS = "";
                                if (carreraGradNAame.codigoModalidad === "P" || carreraGradNAame.codigoModalidad === "S") {
                                    modalidadS = "P";
                                }
                                else if (carreraGradNAame.codigoModalidad === "D" || carreraGradNAame.codigoModalidad === "E") {
                                    modalidadS = "V";
                                }
                                else if (carreraGradNAame.codigoModalidad === "H" || carreraGradNAame.codigoModalidad === "DU") {
                                    modalidadS = "H";
                                }
                                //infoacaid["titulopostgrados"] = "S";
                                //infoacaid["modalidadpost"] = infoacaid["modalidadpost"] !== "" ? infoacaid["modalidadpost"] : modalidadS;
                                //infoacaid["idpais"] = infoacaid["idpais"] !== 0 ? infoacaid["idpais"] : 1;
                                //infoacaid["nombretitulo"] = carreraGradNAame.nombrePrograma;
                                var lastthree = itemGradLength - 1;
                                while (lastthree >= 0 && carrerasgraduado.length <= 3) {
                                    var carreraName = datospostgrados.item.lPostgradosGraduados[lastthree];
                                    carrerasgraduado.push(carreraName.nombrePrograma.toUpperCase());
                                    lastthree = lastthree - 1;
                                }
                                tieneDatosPost = true;
                            }
                            if (datospostgrados.item.lPostgradosActivos !== null && datospostgrados.item.lPostgradosActivos.length > 0) {
                                var itemActLength = datospostgrados.item.lPostgradosActivos.length;
                                var carreraActNAame = datospostgrados.item.lPostgradosActivos[itemActLength - 1];
                                var tipoFormacion = "";
                                if (carreraActNAame.nombrePrograma.startsWith("Maestría")) {
                                    tipoFormacion = "M";
                                }
                                else if (carreraActNAame.nombrePrograma.startsWith("Doctorado")) {
                                    tipoFormacion = "D";
                                }
                                var modalidadC = "";
                                if (carreraActNAame.codigoModalidad === "P" || carreraActNAame.codigoModalidad === "S") {
                                    modalidadC = "P";
                                }
                                else if (carreraActNAame.codigoModalidad === "D" || carreraActNAame.codigoModalidad === "E") {
                                    modalidadC = "V";
                                }
                                else if (carreraActNAame.codigoModalidad === "H" || carreraActNAame.codigoModalidad === "DU") {
                                    modalidadC = "H";
                                }
                                //infoacaid["titulopostgrados"] = "C";
                                //infoacaid["tipopostgradoencurso"] = infoacaid["tipopostgradoencurso"] !== "" ? infoacaid["tipopostgradoencurso"] : tipoFormacion;
                                //infoacaid["modalidadpostencurso"] = infoacaid["modalidadpostencurso"] !== "" ? infoacaid["modalidadpostencurso"] : modalidadC;
                                //infoacaid["idpaisencurso"] = infoacaid["idpaisencurso"] !== 0 ? infoacaid["idpaisencurso"] : 1;
                                //infoacaid["iduniencurso"] = infoacaid["iduniencurso"] !== 0 ? infoacaid["iduniencurso"] : 2068;
                                tieneDatosPost = true;
                            }
                        }
                        var optIntSplit = infoacaid.interes.split(",");
                        var opcionesIntereses = Array();
                        optIntSplit.map(function (opc) {
                            var optionInteres = OpcionesList.InteresList.find(function (obj) { return obj.value === opc; });
                            opcionesIntereses.push(optionInteres);
                        });
                        var optEstAdicSplit = infoacaid.tipoestudiosadicionales.split(",");
                        var opcionesEstudAdicionales = Array();
                        optEstAdicSplit.map(function (opc) {
                            var optionEstudio = OpcionesList.EstudiosAdicionales.find(function (obj) { return obj.value === opc; });
                            opcionesEstudAdicionales.push(optionEstudio);
                        });
                        //console.log("graduadoPost: ", graduadoPost);
                        //console.log("fechaGraduacion: ", fechaGraduacion);
                        //console.log("tieneDatosGrado: ", tieneDatosGrado);
                        var fechaHoy = new Date();
                        var diferencia = fechaHoy.getTime() - fechaGraduacion.getTime();
                        var difDias = diferencia / (1000 * 60 * 60 * 24);
                        var difMeses = diferencia / (1000 * 60 * 60 * 24 * 30);
                        var difAnios = difDias / 365;
                        // DETERMINAR SI ES DE CORTE OBJETIVO Y PREVALECE GRADO
                        if (tieneDatosGrado && graduadoPost && _this.state.encuestaActiva) {
                            //console.log("cumple todas las condiciones");
                            if (difMeses < 15) {
                                graduadoPost = false;
                                infoacaid["tipoalumni"] = "G";
                                infoacaid["carreraalumni"] = datosalumni1.nombrecarrera;
                                infoacaid["fechagraduacion"] = datosalumni1.fechagraduacion;
                                fechaGraduacion = new Date(datosalumni1.fechagraduacion);
                                diferencia = fechaHoy.getTime() - fechaGraduacion.getTime();
                                difMeses = diferencia / (1000 * 60 * 60 * 24 * 30);
                            }
                        }
                        // OPCIONES PARA TIEMPO PRIMER TRABAJO
                        var pTrabajoOpc = [];
                        pTrabajoOpc.push({ "value": "EG", "label": "Empleado antes de la graduación" });
                        if (difMeses >= 0) {
                            pTrabajoOpc.push({ "value": "6M", "label": "Hasta 6 meses" });
                        }
                        if (difMeses >= 7) {
                            pTrabajoOpc.push({ "value": "1A", "label": "Entre 7 y 12 meses" });
                        }
                        if (difMeses >= 13) {
                            pTrabajoOpc.push({ "value": "2A", "label": "Entre 13 y 24 meses" });
                        }
                        if (difMeses > 24) {
                            pTrabajoOpc.push({ "value": "M2M", "label": "Más de 24 meses" });
                        }
                        // OPCIONES PARA MEJORA CONDICIONES (POSTGRADOS)
                        var mejCondOpc = [];
                        mejCondOpc.push({ "value": "6M", "label": "0-6 meses" });
                        if (difMeses >= 7) {
                            mejCondOpc.push({ "value": "12M", "label": "7-12 meses" });
                        }
                        if (difMeses >= 13) {
                            mejCondOpc.push({ "value": "18M", "label": "13-18 meses" });
                        }
                        if (difMeses >= 19) {
                            mejCondOpc.push({ "value": "24M", "label": "19-24 meses" });
                        }
                        if (difMeses > 24) {
                            mejCondOpc.push({ "value": "2A", "label": "Más de 24 meses" });
                        }
                        //console.log("graduadoPost: ", graduadoPost);
                        if (!graduadoPost) { // SI ES DE GRADO, NO DEBE VER NINGUN PREGUNTA
                            infoacaid["titulopostgrados"] = "";
                            infoacaid["tipopostgrado"] = "";
                            infoacaid["otrotipopostgrado"] = "";
                            infoacaid["modalidadpost"] = "";
                            infoacaid["nombreuni"] = "";
                            infoacaid["idpais"] = 0;
                            infoacaid["cursapostgrado"] = "";
                            infoacaid["tipopostgradoencurso"] = "";
                            infoacaid["otrotipopostgradoencurso"] = "";
                            infoacaid["modalidadpostencurso"] = "";
                            infoacaid["nomuniencurso"] = "";
                            infoacaid["idpaisencurso"] = 0;
                            //infoacaid["iduniencurso"] = 0;
                            //infoacaid["relacioncarrpostencurso"] = "";
                            //infoacaid["idpais"] = 0;
                            //infoacaid["nombretitulo"] = "";
                            //infoacaid["relacioncarrera"] = "";
                            //infoacaid["interesadoespol"] = "";
                        }
                        else {
                            if (responsejson.data.tieneTituloSenescyt) {
                                var datosTituloSenescyt = responsejson.data.tituloSenescyt;
                                //console.log("datosTituloSenescyt:", datosTituloSenescyt);
                                infoacaid["titulopostgrados"] = "S";
                                if (datosTituloSenescyt.nombreTitulo.includes("MAGISTER")) {
                                    infoacaid["tipopostgrado"] = "M";
                                }
                                else if (datosTituloSenescyt.nombreTitulo.includes("DOCTOR")) {
                                    infoacaid["tipopostgrado"] = "D";
                                }
                                infoacaid["otrotipopostgrado"] = "";
                                infoacaid["modalidadpost"] = "";
                                infoacaid["nombreuni"] = datosTituloSenescyt.ies;
                            }
                            infoacaid["resolucionproblemas"] = "";
                            infoacaid["pensamientocritico"] = "";
                            infoacaid["comunicacionespanol"] = "";
                            infoacaid["comunicacioningles"] = "";
                            infoacaid["responsabilidadetica"] = "";
                            infoacaid["trabajoequipo"] = "";
                            infoacaid["nuevosconocimientos"] = "";
                            infoacaid["creacionvalor"] = "";
                            infoacaid["habilidadadquirida"] = "";
                        }
                        // INFORMACION LABORAL
                        var infolabid = responsejson.data.tinfolaboral;
                        if (responsejson.data.tinfolaboral.tiempoprimertrabajo !== "") {
                            var opcPrimTrabSel = pTrabajoOpc.filter(function (x) { return x.value === responsejson.data.tinfolaboral.tiempoprimertrabajo; });
                            if (opcPrimTrabSel.length === 0) {
                                infolabid.tiempoprimertrabajo = "";
                            }
                        }
                        // POR CAMBIOS EN LISTA DE SECTORES DE EMPRESA
                        if (responsejson.data.tinfolaboral.sectorempresa !== 0) {
                            var opcSectorEmpresa = _this.state.sectorListSelect.filter(function (x) { return x.value === responsejson.data.tinfolaboral.sectorempresa; });
                            if (opcSectorEmpresa.length === 0) {
                                infolabid.sectorempresa = 0;
                            }
                        }
                        // TELEFONOS
                        var casaalumni = _this.state.telecasaalum;
                        var celularalumni = _this.state.telecelalum;
                        var celuExists = false;
                        var casaExists = false;
                        responsejson.data.ttelefonos.map(function (ta) {
                            if (ta.tipotelefono === "C") {
                                celuExists = true;
                                celularalumni = ta;
                                if (ta.codigopais === "593") {
                                    celularalumni.codigoarea = "09";
                                }
                            }
                            else if (ta.tipotelefono === "D") {
                                casaExists = true;
                                casaalumni = ta;
                                if (ta.codigopais === "593" && ta.codigoarea.length < 2) {
                                    casaalumni.codigoarea = "0" + ta.codigoarea;
                                }
                            }
                        });
                        // EN CASO QUE NO TENGA REGISTRADO ALGUN TIPO DE TELEFONO. DE NO HACERLO IDPERSONA SERIA 0
                        if (!celuExists) {
                            celularalumni.idpersona = idpersonaRJ;
                        }
                        if (!casaExists) {
                            casaalumni.idpersona = idpersonaRJ;
                        }
                        // INFORMACION IMPACTO
                        var infoimpid;
                        if (responsejson.data.tinfoimpacto !== null) {
                            infoimpid = responsejson.data.tinfoimpacto;
                            infoimpid["idpersona"] = idpersonaRJ;
                            if (!graduadoPost) {
                                infoimpid["oportunidadespostgrados"] = "";
                                infoimpid["otrosoportunidades"] = "";
                                infoimpid["tiempomejoracondiciones"] = "";
                                infoimpid["impactoacreditaciones"] = "";
                                infoimpid["motivoimpactonegativo"] = "";
                                infoimpid["integracionredprofesional"] = "";
                                infoimpid["otrosintegracion"] = "";
                                infoimpid["competenciasdesarrolladas"] = "";
                            }
                        }
                        else {
                            infoimpid = new Clases.ImpactoPostgrados();
                            infoimpid.idpersona = idpersonaRJ;
                        }
                        _this.setState({
                            identificacion: numIdentificacion,
                            infopersonal: responsejson.data.tinfopersonal,
                            infoacademica: infoacaid, infolaboral: infolabid,
                            infoimpacto: infoimpid, telecasaalum: casaalumni, telecelalum: celularalumni,
                            tipoFonoSelect: "C", cedulaModal: false,
                            //cargandoValidAlert: false,
                            datosalumni: datosalumni1, idpersona: idpersonaRJ,
                            opcionesInteres: opcionesIntereses,
                            opcionesEstudAdic: opcionesEstudAdicionales,
                            graduadode: carrerasgraduado,
                            tieneDatosPost: tieneDatosPost,
                            graduadoPost: graduadoPost,
                            opcionesPrimerTrabajo: pTrabajoOpc,
                            opcionesMejorCondicion: mejCondOpc
                        }, function () {
                            sweetalert2_1.default.close();
                        });
                    }
                    else {
                        //cargaExitosa = false;
                        var mensaje = "Ocurrió un error al obtener la información.";
                        //this.setState({ cedulaModal: true, cedulaAlert: true, mensajeAlerta: mensaje, cargandoValidAlert: false });
                        console.log("Ocurrió un error en GetAllInformation.");
                        sweetalert2_1.default.fire({
                            title: '¡Oh no!',
                            text: 'Se ha producido un error al momento de obtener su información',
                            icon: 'error',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then(function (result) {
                            if (result.isConfirmed) {
                                sweetalert2_1.default.close();
                            }
                        });
                    }
                }, function (error) {
                    if (error.name === "AbortError") {
                        console.log("AbortError controlado");
                    }
                    else {
                        //cargaExitosa = false;
                        var mensaje = "Ocurrió un error al obtener la información.";
                        //this.setState({ cedulaModal: true, cedulaAlert: true, mensajeAlerta: mensaje, cargandoValidAlert: false });
                        console.log("Ocurrió un error en GetAllInformation: " + error);
                        sweetalert2_1.default.fire({
                            title: '¡Oh no!',
                            text: 'Se ha producido un error al momento de obtener su información',
                            icon: 'error',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then(function (result) {
                            if (result.isConfirmed) {
                                sweetalert2_1.default.close();
                            }
                        });
                    }
                });
            }
            else {
                var mensaje = "Ocurrió un error al guardar la información de inicio de sesión.";
                //this.setState({ cedulaModal: true, cedulaAlert: true, mensajeAlerta: mensaje, cargandoValidAlert: false });
                //console.log("Ocurrió un error en PostDatosLogin: " + responsePost["strMensaje"]);
                console.log("Ocurrió un error en PostDatosLogin: " + responsePost.status.messages);
                sweetalert2_1.default.fire({
                    title: '¡Oh no!',
                    text: 'Se ha producido un error al momento de obtener su información',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then(function (result) {
                    if (result.isConfirmed) {
                        sweetalert2_1.default.close();
                    }
                });
            }
        }, function (error) {
            if (error.name === "AbortError") {
                console.log("AbortError controlado");
            }
            else {
                var mensaje = "Ocurrió un error al guardar la información de inicio de sesión.";
                //this.setState({ cedulaModal: true, cedulaAlert: true, mensajeAlerta: mensaje, cargandoValidAlert: false });
                console.log("Ocurrió un error en PostDatosLogin: " + error);
                sweetalert2_1.default.fire({
                    title: '¡Oh no!',
                    text: 'Se ha producido un error al momento de guardar la información de inicio de sesión.',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then(function (result) {
                    if (result.isConfirmed) {
                        sweetalert2_1.default.close();
                    }
                });
            }
        });
    };
    FormularioAlumni.prototype.showDatosAlumni = function (idpersonaRJ, datosalumni1, datospostgrados, datospersonal, datosacademica, datoslaboral, datosimpacto, datostelefono, tieneTituloSenescyt, datosTituloSenescyt) {
        // INFORMACION PERSONAL
        // ACTUALIZANDO EMAIL ALTERNO
        if (this.state.redSocial !== "" && this.state.redSocial !== "I") {
            datospersonal.emailalterno = this.state.emailRedsocial;
        }
        // INFORMACION ACADEMICA
        var infoacaid;
        if (datosacademica !== null) {
            infoacaid = datosacademica;
        }
        else {
            infoacaid = new Clases.InfoAcademica();
            infoacaid.idpersona = idpersonaRJ;
            infoacaid.fechagraduacion = null;
        }
        var tieneDatosGrado = false;
        var tieneDatosPost = false;
        var graduadoPost = false;
        var carrerasgraduado = Array();
        var fechaGraduacion = new Date();
        // agregando carrera de grado
        if (datosalumni1 !== null && datosalumni1.nombrecarrera !== null) {
            infoacaid["tipoalumni"] = "G";
            infoacaid["carreraalumni"] = datosalumni1.nombrecarrera;
            infoacaid["fechagraduacion"] = datosalumni1.fechagraduacion;
            carrerasgraduado.push(datosalumni1.nombrecarrera.toUpperCase());
            fechaGraduacion = new Date(datosalumni1.fechagraduacion);
            tieneDatosGrado = true;
        }
        if (datospostgrados !== null && datospostgrados.item !== null) {
            if (datospostgrados.item.lPostgradosGraduados !== null && datospostgrados.item.lPostgradosGraduados.length > 0) {
                var itemGradLength = datospostgrados.item.lPostgradosGraduados.length;
                var carreraGradNAame = datospostgrados.item.lPostgradosGraduados[itemGradLength - 1];
                graduadoPost = true;
                infoacaid["tipoalumni"] = "P";
                infoacaid["carreraalumni"] = carreraGradNAame.nombrePrograma;
                infoacaid["fechagraduacion"] = carreraGradNAame.fechaGraduacion;
                fechaGraduacion = new Date(carreraGradNAame.fechaGraduacion);
                var modalidadS = "";
                if (carreraGradNAame.codigoModalidad === "P" || carreraGradNAame.codigoModalidad === "S") {
                    modalidadS = "P";
                }
                else if (carreraGradNAame.codigoModalidad === "D" || carreraGradNAame.codigoModalidad === "E") {
                    modalidadS = "V";
                }
                else if (carreraGradNAame.codigoModalidad === "H" || carreraGradNAame.codigoModalidad === "DU") {
                    modalidadS = "H";
                }
                //infoacaid["titulopostgrados"] = "S";
                //infoacaid["modalidadpost"] = infoacaid["modalidadpost"] !== "" ? infoacaid["modalidadpost"] : modalidadS;
                //infoacaid["idpais"] = infoacaid["idpais"] !== 0 ? infoacaid["idpais"] : 1;
                //infoacaid["nombretitulo"] = carreraGradNAame.nombrePrograma;
                var lastthree = itemGradLength - 1;
                while (lastthree >= 0 && carrerasgraduado.length <= 3) {
                    var carreraName = datospostgrados.item.lPostgradosGraduados[lastthree];
                    carrerasgraduado.push(carreraName.nombrePrograma.toUpperCase());
                    lastthree = lastthree - 1;
                }
                tieneDatosPost = true;
            }
            if (datospostgrados.item.lPostgradosActivos !== null && datospostgrados.item.lPostgradosActivos.length > 0) {
                var itemActLength = datospostgrados.item.lPostgradosActivos.length;
                var carreraActNAame = datospostgrados.item.lPostgradosActivos[itemActLength - 1];
                var tipoFormacion = "";
                if (carreraActNAame.nombrePrograma.startsWith("Maestría")) {
                    tipoFormacion = "M";
                }
                else if (carreraActNAame.nombrePrograma.startsWith("Doctorado")) {
                    tipoFormacion = "D";
                }
                var modalidadC = "";
                if (carreraActNAame.codigoModalidad === "P" || carreraActNAame.codigoModalidad === "S") {
                    modalidadC = "P";
                }
                else if (carreraActNAame.codigoModalidad === "D" || carreraActNAame.codigoModalidad === "E") {
                    modalidadC = "V";
                }
                else if (carreraActNAame.codigoModalidad === "H" || carreraActNAame.codigoModalidad === "DU") {
                    modalidadC = "H";
                }
                //infoacaid["titulopostgrados"] = "C";
                //infoacaid["tipopostgradoencurso"] = infoacaid["tipopostgradoencurso"] !== "" ? infoacaid["tipopostgradoencurso"] : tipoFormacion;
                //infoacaid["modalidadpostencurso"] = infoacaid["modalidadpostencurso"] !== "" ? infoacaid["modalidadpostencurso"] : modalidadC;
                //infoacaid["idpaisencurso"] = infoacaid["idpaisencurso"] !== 0 ? infoacaid["idpaisencurso"] : 1;
                //infoacaid["iduniencurso"] = infoacaid["iduniencurso"] !== 0 ? infoacaid["iduniencurso"] : 2068;
                tieneDatosPost = true;
            }
        }
        var optIntSplit = infoacaid.interes.split(",");
        var opcionesIntereses = Array();
        optIntSplit.map(function (opc) {
            var optionInteres = OpcionesList.InteresList.find(function (obj) { return obj.value === opc; });
            opcionesIntereses.push(optionInteres);
        });
        var optEstAdicSplit = infoacaid.tipoestudiosadicionales.split(",");
        var opcionesEstudAdicionales = Array();
        optEstAdicSplit.map(function (opc) {
            var optionEstudio = OpcionesList.EstudiosAdicionales.find(function (obj) { return obj.value === opc; });
            opcionesEstudAdicionales.push(optionEstudio);
        });
        //console.log("graduadoPost: ", graduadoPost);
        //console.log("fechaGraduacion: ", fechaGraduacion);
        //console.log("tieneDatosGrado: ", tieneDatosGrado);
        var fechaHoy = new Date();
        var diferencia = fechaHoy.getTime() - fechaGraduacion.getTime();
        var difDias = diferencia / (1000 * 60 * 60 * 24);
        var difMeses = diferencia / (1000 * 60 * 60 * 24 * 30);
        var difAnios = difDias / 365;
        // DETERMINAR SI ES DE CORTE OBJETIVO Y PREVALECE GRADO
        if (tieneDatosGrado && graduadoPost && this.state.encuestaActiva) {
            //console.log("cumple todas las condiciones");
            if (difMeses < 15) {
                graduadoPost = false;
                infoacaid["tipoalumni"] = "G";
                infoacaid["carreraalumni"] = datosalumni1.nombrecarrera;
                infoacaid["fechagraduacion"] = datosalumni1.fechagraduacion;
                fechaGraduacion = new Date(datosalumni1.fechagraduacion);
                diferencia = fechaHoy.getTime() - fechaGraduacion.getTime();
                difMeses = diferencia / (1000 * 60 * 60 * 24 * 30);
            }
        }
        // OPCIONES PARA TIEMPO PRIMER TRABAJO
        var pTrabajoOpc = [];
        pTrabajoOpc.push({ "value": "EG", "label": "Empleado antes de la graduación" });
        if (difMeses >= 0) {
            pTrabajoOpc.push({ "value": "6M", "label": "Hasta 6 meses" });
        }
        if (difMeses >= 7) {
            pTrabajoOpc.push({ "value": "1A", "label": "Entre 7 y 12 meses" });
        }
        if (difMeses >= 13) {
            pTrabajoOpc.push({ "value": "2A", "label": "Entre 13 y 24 meses" });
        }
        if (difMeses > 24) {
            pTrabajoOpc.push({ "value": "M2M", "label": "Más de 24 meses" });
        }
        // OPCIONES PARA MEJORA CONDICIONES (POSTGRADOS)
        var mejCondOpc = [];
        mejCondOpc.push({ "value": "6M", "label": "0-6 meses" });
        if (difMeses >= 7) {
            mejCondOpc.push({ "value": "12M", "label": "7-12 meses" });
        }
        if (difMeses >= 13) {
            mejCondOpc.push({ "value": "18M", "label": "13-18 meses" });
        }
        if (difMeses >= 19) {
            mejCondOpc.push({ "value": "24M", "label": "19-24 meses" });
        }
        if (difMeses > 24) {
            mejCondOpc.push({ "value": "2A", "label": "Más de 24 meses" });
        }
        //console.log("graduadoPost: ", graduadoPost);
        if (!graduadoPost) { // SI ES DE GRADO, NO DEBE VER NINGUN PREGUNTA
            infoacaid["titulopostgrados"] = "";
            infoacaid["tipopostgrado"] = "";
            infoacaid["otrotipopostgrado"] = "";
            infoacaid["modalidadpost"] = "";
            infoacaid["nombreuni"] = "";
            infoacaid["idpais"] = 0;
            infoacaid["cursapostgrado"] = "";
            infoacaid["tipopostgradoencurso"] = "";
            infoacaid["otrotipopostgradoencurso"] = "";
            infoacaid["modalidadpostencurso"] = "";
            infoacaid["nomuniencurso"] = "";
            infoacaid["idpaisencurso"] = 0;
            //infoacaid["iduniencurso"] = 0;
            //infoacaid["relacioncarrpostencurso"] = "";
            //infoacaid["idpais"] = 0;
            //infoacaid["nombretitulo"] = "";
            //infoacaid["relacioncarrera"] = "";
            //infoacaid["interesadoespol"] = "";
        }
        else {
            if (tieneTituloSenescyt) {
                //console.log("datosTituloSenescyt:", datosTituloSenescyt);
                infoacaid["titulopostgrados"] = "S";
                if (datosTituloSenescyt.nombreTitulo.includes("MAGISTER")) {
                    infoacaid["tipopostgrado"] = "M";
                }
                else if (datosTituloSenescyt.nombreTitulo.includes("DOCTOR")) {
                    infoacaid["tipopostgrado"] = "D";
                }
                infoacaid["otrotipopostgrado"] = "";
                infoacaid["modalidadpost"] = "";
                infoacaid["nombreuni"] = datosTituloSenescyt.ies;
            }
            infoacaid["resolucionproblemas"] = "";
            infoacaid["pensamientocritico"] = "";
            infoacaid["comunicacionespanol"] = "";
            infoacaid["comunicacioningles"] = "";
            infoacaid["responsabilidadetica"] = "";
            infoacaid["trabajoequipo"] = "";
            infoacaid["nuevosconocimientos"] = "";
            infoacaid["creacionvalor"] = "";
            infoacaid["habilidadadquirida"] = "";
        }
        // INFORMACION LABORAL
        var infolabid = datoslaboral;
        if (datoslaboral.tiempoprimertrabajo !== "") {
            var opcPrimTrabSel = pTrabajoOpc.filter(function (x) { return x.value === datoslaboral.tiempoprimertrabajo; });
            if (opcPrimTrabSel.length === 0) {
                infolabid.tiempoprimertrabajo = "";
            }
        }
        // POR CAMBIOS EN LISTA DE SECTORES DE EMPRESA
        if (datoslaboral.sectorempresa !== 0) {
            var opcSectorEmpresa = this.state.sectorListSelect.filter(function (x) { return x.value === datoslaboral.sectorempresa; });
            if (opcSectorEmpresa.length === 0) {
                infolabid.sectorempresa = 0;
            }
        }
        // TELEFONOS
        var casaalumni = this.state.telecasaalum;
        var celularalumni = this.state.telecelalum;
        var celuExists = false;
        var casaExists = false;
        datostelefono.map(function (ta) {
            if (ta.tipotelefono === "C") {
                celuExists = true;
                celularalumni = ta;
                if (ta.codigopais === "593") {
                    celularalumni.codigoarea = "09";
                }
            }
            else if (ta.tipotelefono === "D") {
                casaExists = true;
                casaalumni = ta;
                if (ta.codigopais === "593" && ta.codigoarea.length < 2) {
                    casaalumni.codigoarea = "0" + ta.codigoarea;
                }
            }
        });
        // EN CASO QUE NO TENGA REGISTRADO ALGUN TIPO DE TELEFONO. DE NO HACERLO IDPERSONA SERIA 0
        if (!celuExists) {
            celularalumni.idpersona = idpersonaRJ;
        }
        if (!casaExists) {
            casaalumni.idpersona = idpersonaRJ;
        }
        // INFORMACION IMPACTO
        var infoimpid;
        if (datosimpacto !== null) {
            if (!graduadoPost) {
                datosimpacto["oportunidadespostgrados"] = "";
                datosimpacto["otrosoportunidades"] = "";
                datosimpacto["tiempomejoracondiciones"] = "";
                datosimpacto["impactoacreditaciones"] = "";
                datosimpacto["motivoimpactonegativo"] = "";
                datosimpacto["integracionredprofesional"] = "";
                datosimpacto["otrosintegracion"] = "";
                datosimpacto["competenciasdesarrolladas"] = "";
            }
            datosimpacto["idpersona"] = idpersonaRJ;
            infoimpid = datosimpacto;
        }
        else {
            infoimpid = new Clases.ImpactoPostgrados();
            infoimpid.idpersona = idpersonaRJ;
        }
        this.setState({
            identificacion: datosalumni1.numeroidentificacion,
            infopersonal: datospersonal,
            infoacademica: infoacaid, infolaboral: infolabid,
            infoimpacto: infoimpid, telecasaalum: casaalumni, telecelalum: celularalumni,
            tipoFonoSelect: "C", cedulaModal: false,
            //cargandoValidAlert: false,
            datosalumni: datosalumni1, idpersona: idpersonaRJ,
            opcionesInteres: opcionesIntereses,
            opcionesEstudAdic: opcionesEstudAdicionales,
            graduadode: carrerasgraduado,
            tieneDatosPost: tieneDatosPost,
            graduadoPost: graduadoPost,
            opcionesPrimerTrabajo: pTrabajoOpc,
            opcionesMejorCondicion: mejCondOpc
        }, function () {
            sweetalert2_1.default.close();
        });
    };
    FormularioAlumni.prototype.exceptionsInput = function (event) {
        var validNum;
        if (event.key !== undefined) {
            validNum = event.key === "e" || event.key === "E" || event.key === "." || event.key === "+" || event.key === "-" || event.key === ",";
        }
        else if (event.keyCode !== undefined) {
            validNum = event.keyCode === 69 || event.keyCode === 190 || event.keyCode === 187 || event.keyCode === 189 || event.keyCode === 188;
        }
        return validNum && event.preventDefault();
    };
    FormularioAlumni.prototype.exceptionsTextInput = function (event) {
        var validText;
        if (event.key !== undefined) {
            validText = event.key === "0" || event.key === "1" || event.key === "2" || event.key === "3" || event.key === "4" || event.key === "5" || event.key === "6" || event.key === "7" || event.key === "8" || event.key === "9";
        }
        else if (event.keyCode !== undefined) {
            validText = (event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105);
        }
        return validText && event.preventDefault();
    };
    FormularioAlumni.prototype.validarCambiosSeccion = function (event, objeto1, tipoFono, telefonocasa, telefonomovil) {
        event.preventDefault();
        if (event.target.name === "alumniform-personal") {
            document.getElementById("personal-section").style.display = "none";
            document.getElementById("laboral-section").style.removeProperty("display");
            document.getElementById("banner-banner").scrollIntoView({
                behavior: "smooth", block: "start", inline: "center"
            });
            var progressValueper = this.state.progressValue;
            //if (this.state.graduadoPost) {
            //    progressValueper = progressValueper + 14;
            //} else { progressValueper = progressValueper + 17; }
            progressValueper = progressValueper + 14;
            this.setState({
                infopersonal: objeto1, progressValue: progressValueper, tipoFonoSelect: tipoFono,
                telecasaalum: telefonocasa, telecelalum: telefonomovil
            });
        }
        else if (event.target.name === "alumniform-laboral") { // EN LABORAL
            var dtoInfoLaboral = objeto1; //this.state.infolaboral;
            var forma = new FormData(event.target);
            var fields = ["cantpersonascargo", "aniosexperiencia", "salariomensual", "aniosnp", "utilidades", "bonificaciones"];
            forma.forEach(function (value, key) {
                var splitkey = key.split("-");
                if (splitkey[0] === "inflab" && typeof dtoInfoLaboral[splitkey[1]] === 'string' && fields.indexOf(splitkey[1]) !== -1) {
                    dtoInfoLaboral[splitkey[1]] = Number(value);
                }
            });
            var progressValuelab = this.state.progressValue;
            if (this.state.infolaboral.situacionlaboral !== "BPT" && this.state.infolaboral.situacionlaboral !== "SE" && this.state.infolaboral.situacionlaboral !== "ND" && this.state.infolaboral.situacionlaboral !== "PN") {
                document.getElementById("laboral-section").style.display = "none";
                document.getElementById("laboral-section-p2").style.removeProperty("display");
                document.getElementById("banner-banner").scrollIntoView({
                    behavior: "smooth", block: "start", inline: "center"
                });
                //if (this.state.graduadoPost) {
                //    progressValuelab = progressValuelab + 14;
                //} else { progressValuelab = progressValuelab + 17; }
                progressValueper = progressValueper + 14;
            }
            else {
                document.getElementById("laboral-section").style.display = "none";
                document.getElementById("emprendimiento-section").style.removeProperty("display");
                document.getElementById("banner-banner").scrollIntoView({
                    behavior: "smooth", block: "start", inline: "center"
                });
                //if (this.state.graduadoPost) {
                //    progressValuelab = progressValuelab + 17;
                //} else { progressValuelab = progressValuelab + 20; }
                progressValueper = progressValueper + 17;
            }
            this.setState({ infolaboral: objeto1, progressValue: progressValuelab });
        }
        else if (event.target.name === "alumniform-laboral-p2") { // EN LABORAL PARTE 2
            var dtoInfoLaboral = objeto1; //this.state.infolaboral;
            var forma = new FormData(event.target);
            var fields = ["cantpersonascargo", "aniosexperiencia", "salariomensual", "aniosnp", "utilidades", "bonificaciones"];
            forma.forEach(function (value, key) {
                var splitkey = key.split("-");
                if (splitkey[0] === "inflab" && typeof dtoInfoLaboral[splitkey[1]] === 'string' && fields.indexOf(splitkey[1]) !== -1) {
                    dtoInfoLaboral[splitkey[1]] = Number(value);
                }
            });
            document.getElementById("laboral-section-p2").style.display = "none";
            document.getElementById("emprendimiento-section").style.removeProperty("display");
            document.getElementById("banner-banner").scrollIntoView({
                behavior: "smooth", block: "start", inline: "center"
            });
            var progressValuelab2 = this.state.progressValue;
            //if (this.state.graduadoPost) {
            //    progressValuelab2 = progressValuelab2 + 14;
            //} else { progressValuelab2 = progressValuelab2 + 17; }
            progressValueper = progressValueper + 14;
            this.setState({ infolaboral: objeto1, progressValue: progressValuelab2 });
        }
        else if (event.target.name === "alumniform-emprendimiento") { // EN EMPRENDIMIENTO
            var progressValueemp = this.state.progressValue;
            document.getElementById("emprendimiento-section").style.display = "none";
            //if (this.state.graduadoPost) {
            //    (document.getElementById("impacto-section") as HTMLInputElement).style.removeProperty("display");
            //    (document.getElementById("banner-banner") as HTMLInputElement).scrollIntoView({
            //        behavior: "smooth", block: "start", inline: "center"
            //    });
            //    progressValueemp = progressValueemp + 14;
            //} else {
            //    (document.getElementById("academica-section") as HTMLInputElement).style.removeProperty("display");
            //    (document.getElementById("banner-banner") as HTMLInputElement).scrollIntoView({
            //        behavior: "smooth", block: "start", inline: "center"
            //    });
            //    progressValueemp = progressValueemp + 17;
            //}
            // AHORA LA SECCION DE IMPACTO LA VEN TODOS LOS ALUMNI - 17/09/2025
            document.getElementById("impacto-section").style.removeProperty("display");
            document.getElementById("banner-banner").scrollIntoView({
                behavior: "smooth", block: "start", inline: "center"
            });
            progressValueemp = progressValueemp + 14;
            this.setState({ infolaboral: objeto1, progressValue: progressValueemp });
        }
        else if (event.target.name === "alumniform-impacto") { // EN IMPACTO
            document.getElementById("impacto-section").style.display = "none";
            document.getElementById("academica-section").style.removeProperty("display");
            document.getElementById("banner-banner").scrollIntoView({
                behavior: "smooth", block: "start", inline: "center"
            });
            var progressValueimp = this.state.progressValue;
            progressValueimp = progressValueimp + 14;
            this.setState({ infoimpacto: objeto1, progressValue: progressValueimp });
        }
        else if (event.target.name === "alumniform-academica") { // EN ACADEMICA
            document.getElementById("academica-section").style.display = "none";
            document.getElementById("interes-section").style.removeProperty("display");
            document.getElementById("banner-banner").scrollIntoView({
                behavior: "smooth", block: "start", inline: "center"
            });
            var progressValueaca = this.state.progressValue;
            //if (this.state.graduadoPost) {
            //    progressValueaca = progressValueaca + 14;
            //} else { progressValueaca = progressValueaca + 17; }
            progressValueaca = progressValueaca + 14;
            this.setState({ infoacademica: objeto1, progressValue: progressValueaca });
        }
    };
    FormularioAlumni.prototype.retrocederSeccion = function (event) {
        if (event.target.name === "prev-laboral-button") { // EN LABORAL
            document.getElementById("laboral-section").style.display = "none";
            document.getElementById("personal-section").style.removeProperty("display");
            document.getElementById("banner-banner").scrollIntoView({
                behavior: "smooth", block: "start", inline: "center"
            });
            var progressValue = this.state.progressValue;
            if (this.state.graduadoPost) {
                progressValue = progressValue - 14;
            }
            else {
                progressValue = progressValue - 17;
            }
            this.setState({ progressValue: progressValue });
        }
        else if (event.target.name === "prev-laboral-p2-button") { // EN LABORAL 2
            document.getElementById("laboral-section-p2").style.display = "none";
            document.getElementById("laboral-section").style.removeProperty("display");
            document.getElementById("banner-banner").scrollIntoView({
                behavior: "smooth", block: "start", inline: "center"
            });
            var progressValue = this.state.progressValue;
            if (this.state.graduadoPost) {
                progressValue = progressValue - 14;
            }
            else {
                progressValue = progressValue - 17;
            }
            this.setState({ progressValue: progressValue });
        }
        else if (event.target.name === "prev-emprend-button") { // EN EMPRENDIMIENTO
            var progressValue = this.state.progressValue;
            if (this.state.infolaboral.situacionlaboral !== "BPT" && this.state.infolaboral.situacionlaboral !== "SE" && this.state.infolaboral.situacionlaboral !== "ND" && this.state.infolaboral.situacionlaboral !== "PN") {
                document.getElementById("emprendimiento-section").style.display = "none";
                document.getElementById("laboral-section-p2").style.removeProperty("display");
                document.getElementById("banner-banner").scrollIntoView({
                    behavior: "smooth", block: "start", inline: "center"
                });
                if (this.state.graduadoPost) {
                    progressValue = progressValue - 14;
                }
                else {
                    progressValue = progressValue - 17;
                }
            }
            else {
                document.getElementById("emprendimiento-section").style.display = "none";
                document.getElementById("laboral-section").style.removeProperty("display");
                document.getElementById("banner-banner").scrollIntoView({
                    behavior: "smooth", block: "start", inline: "center"
                });
                if (this.state.graduadoPost) {
                    progressValue = progressValue - 17;
                }
                else {
                    progressValue = progressValue - 20;
                }
            }
            this.setState({ progressValue: progressValue });
        }
        else if (event.target.name === "prev-impacto-button") { // EN IMPACTO
            document.getElementById("impacto-section").style.display = "none";
            document.getElementById("emprendimiento-section").style.removeProperty("display");
            document.getElementById("banner-banner").scrollIntoView({
                behavior: "smooth", block: "start", inline: "center"
            });
            var progressValue = this.state.progressValue;
            progressValue = progressValue - 14;
            this.setState({ progressValue: progressValue });
        }
        else if (event.target.name === "prev-academica-button") { // EN ACADEMICA
            var progressValue = this.state.progressValue;
            document.getElementById("academica-section").style.display = "none";
            if (this.state.graduadoPost) {
                document.getElementById("impacto-section").style.removeProperty("display");
                document.getElementById("banner-banner").scrollIntoView({
                    behavior: "smooth", block: "start", inline: "center"
                });
                progressValue = progressValue - 14;
            }
            else {
                document.getElementById("emprendimiento-section").style.removeProperty("display");
                document.getElementById("banner-banner").scrollIntoView({
                    behavior: "smooth", block: "start", inline: "center"
                });
                progressValue = progressValue - 17;
            }
            this.setState({ progressValue: progressValue });
        }
        else if (event.target.name === "prev-interes-button") { // EN INTERESES
            document.getElementById("interes-section").style.display = "none";
            document.getElementById("academica-section").style.removeProperty("display");
            document.getElementById("banner-banner").scrollIntoView({
                behavior: "smooth", block: "start", inline: "center"
            });
            var progressValue = this.state.progressValue;
            if (this.state.graduadoPost) {
                progressValue = progressValue - 14;
            }
            else {
                progressValue = progressValue - 17;
            }
            this.setState({ progressValue: progressValue });
        }
    };
    FormularioAlumni.prototype.resetFormulario = function () {
        if (this.state.alertExito) {
            this.setState({
                loading: true, error: null,
                identificacion: "", dia: "", mes: "", anio: "", idpersona: 0, tieneDatosPost: false, graduadoPost: false,
                //datosalumni: new Clases.DatosAlumni(), infopersonal: new Clases.InfoPersonal(), infolaboral: new Clases.InfoLaboral(), infoacademica: new Clases.InfoAcademica(), infoimpacto: new Clases.ImpactoPostgrados(),
                datosalumni: null, infopersonal: null, infolaboral: null, infoacademica: null, infoimpacto: null,
                telecasaalum: new Clases.TblTelefonoInfo(), telecelalum: new Clases.TblTelefonoInfo(), tipoFonoSelect: "",
                cedulaModal: true, modalEnd: false, alertCargando: false, alertExito: false, alertError: false,
                graduadode: [], progressValue: 0,
                loginOpen: true, redSocial: "", emailRedsocial: "", opcionesPrimerTrabajo: [], opcionesMejorCondicion: []
            }, function () {
                document.getElementById("banner-banner").scrollIntoView({
                    behavior: "smooth", block: "start", inline: "center"
                });
            });
        }
        else if (this.state.alertError) {
            this.setState({ modalEnd: false });
        }
    };
    FormularioAlumni.prototype.handleSubmit = function (event, dtolaboral, dtoacademica) {
        var _this = this;
        event.preventDefault();
        var forma = new FormData(event.target);
        var datosAlumni = this.state.datosalumni;
        var dtoInfoPersonal = this.state.infopersonal;
        var dtoInfoLaboral = dtolaboral; //this.state.infolaboral;
        var dtoInfoAcademica = dtoacademica; //this.state.infoacademica;
        var dtoInfoImpacto = this.state.infoimpacto;
        var tele1c = this.state.telecasaalum;
        var tele1m = this.state.telecelalum;
        var isformvalid = true;
        var telefonosList = Array();
        telefonosList.push(tele1c);
        telefonosList.push(tele1m);
        //actualizando con datos del registro civil
        dtoInfoPersonal.estadocivil = datosAlumni.estadocivil;
        if (isformvalid) {
            this.setState({ modalEnd: true, alertCargando: true }, function () {
                document.getElementById("informacion-personal").scrollIntoView({
                    behavior: "smooth", block: "start", inline: "center"
                });
            });
            var telefonoPost;
            if (this.state.tipoFonoSelect === "C") {
                telefonoPost = tele1m;
            }
            else if (this.state.tipoFonoSelect === "D") {
                telefonoPost = tele1c;
            }
            var datosFormulario = JSON.stringify({
                "tinfopersonal": dtoInfoPersonal, "tinfolaboral": dtoInfoLaboral, "tinfoacademica": dtoInfoAcademica,
                "ttelefono": telefonoPost, "tinfoimpacto": dtoInfoImpacto
            });
            // PostDatosFormulario
            fetch(SERVER_URL + "Formulario/PostDatosFormulario", {
                method: 'POST', headers: { 'Content-Type': 'application/json' }, body: datosFormulario
            }).then(function (response) { return response.json(); })
                .then(function (responseJson) {
                //console.log("PostDatosFormulario: ", responseJson);
                //if (responseJson["strEstado"] === "N") {
                if (!responseJson.status.isSuccessfully) {
                    _this.setState({ alertError: true, alertCargando: false });
                    //} else if (responseJson["strEstado"] === "S") {
                }
                else if (responseJson.status.isSuccessfully) {
                    _this.setState({ alertExito: true, alertCargando: false });
                }
                else {
                    _this.setState({ alertError: true, alertCargando: false });
                }
            }).catch(function (error) {
                _this.setState({ alertError: true, alertCargando: false });
                console.log("Ocurrió un error al registrar: " + error);
            });
        }
    };
    FormularioAlumni.prototype.render = function () {
        var content = this.state.paisesSelectList.length > 0 && this.state.paisFonoSelectList.length > 0 && this.state.provinciasSelectList.length > 0 && this.state.ciudadesSelectList.length > 0 && this.state.parroquiasSelectList.length > 0 && this.state.universidadSelectList.length > 0 && this.state.sectorListSelect.length > 0
            ?
                this.renderForm(this.state.paisesSelectList, this.state.paisFonoSelectList, this.state.sectorListSelect, this.state.universidadSelectList)
            :
                React.createElement("div", { className: "loading" },
                    React.createElement("div", { className: "spinner-border text-secondary", role: "status" },
                        React.createElement("span", { className: "visually-hidden" })),
                    React.createElement("span", null, "\u00A0Cargando"));
        return (React.createElement("div", null, content));
    };
    FormularioAlumni.prototype.renderForm = function (paisesList, paisesFonoList, sectorList, universidadList) {
        return (React.createElement(React.Fragment, null,
            React.createElement("img", { id: "banner-banner", src: Banner, alt: "", style: { width: "100%" } }),
            React.createElement("div", { className: "col-sm-1" }),
            React.createElement("div", { className: "container-fluid col-sm-10" },
                React.createElement(reactstrap_1.Modal, { isOpen: this.state.cedulaModal, centered: true, size: "lg" },
                    React.createElement(reactstrap_1.ModalHeader, { className: "modal-header-style" }, this.state.loginOpen ? "Inicio de sesión" : "Validación de datos"),
                    React.createElement(reactstrap_1.ModalBody, null,
                        (this.state.loginOpen) && (React.createElement(LoginRedes_js_1.default, { closeLoginRedes: this.closeLoginRedes, closeLoginEspol: this.closeLoginEspol, actDatos: false })),
                        !(this.state.loginOpen) && (React.createElement(verificacion_cedula_js_1.default, { closeVerificacionCedula: this.closeVerificacionCedula, actDatos: false })))),
                React.createElement(reactstrap_1.Modal, { isOpen: this.state.modalEnd, centered: true },
                    React.createElement(reactstrap_1.ModalBody, null,
                        React.createElement(reactstrap_1.Alert, { isOpen: this.state.alertCargando, color: "light" },
                            React.createElement("div", { className: "spinner-border text-secondary", role: "status" },
                                React.createElement("span", { className: "visually-hidden" })),
                            "\u00A0Cargando"),
                        React.createElement(reactstrap_1.Alert, { isOpen: this.state.alertExito }, "Su formulario se ha registrado con \u00E9xito."),
                        React.createElement(reactstrap_1.Alert, { isOpen: this.state.alertError, color: "danger" }, "Se ha producido un error al momento de guardar la informaci\u00F3n."),
                        React.createElement("div", { className: "form-group row", id: "cerrarForm", style: { float: "right" } },
                            React.createElement("button", { type: "button", className: "btn btn-info buttonSpace", disabled: this.state.alertCargando, onClick: this.resetFormulario }, "Cerrar")))),
                React.createElement(reactstrap_1.Progress, { color: "info", value: this.state.progressValue, animated: true }),
                React.createElement("br", null),
                React.createElement("br", null),
                this.state.datosalumni === null && this.state.infopersonal === null && this.state.infolaboral === null && this.state.infoacademica === null && this.state.infoimpacto === null
                    ?
                        React.createElement("div", { className: "loading" },
                            React.createElement("div", { className: "spinner-border text-secondary", role: "status" },
                                React.createElement("span", { className: "visually-hidden" })),
                            React.createElement("span", null, "\u00A0Cargando"))
                    :
                        React.createElement(React.Fragment, null,
                            React.createElement("div", { id: "personal-section" },
                                React.createElement(InformacionPersonal_1.InformacionPersonal, { datosalumni: this.state.datosalumni, infopersonal: this.state.infopersonal, telecelalum: this.state.telecelalum, telecasaalum: this.state.telecasaalum, paisesSelectList: paisesList, provinciasSelectList: this.state.provinciasSelectList, ciudadesSelectList: this.state.ciudadesSelectList, parroquiasSelectList: this.state.parroquiasSelectList, graduadode: this.state.graduadode, paisesList: this.state.paisesList, paisesFonoList: paisesFonoList, exceptionsInput: this.exceptionsInput, validarCambiosSeccion: this.validarCambiosSeccion })),
                            React.createElement("div", { id: "laboral-section", style: { display: "none" } },
                                React.createElement(InformacionLaboral_1.InformacionLaboral, { infolaboral: this.state.infolaboral, graduadoPost: this.state.graduadoPost, paisesSelectList: paisesList, provinciasSelectList: this.state.provinciasSelectList, ciudadesSelectList: this.state.ciudadesSelectList, sectorList: sectorList, opcionesPrimerTrabajo: this.state.opcionesPrimerTrabajo, exceptionsInput: this.exceptionsInput, exceptionsTextInput: this.exceptionsTextInput, retrocederSeccion: this.retrocederSeccion, validarCambiosSeccion: this.validarCambiosSeccion })),
                            React.createElement("div", { id: "laboral-section-p2", style: { display: "none" } },
                                React.createElement(InformacionLaboralParte2_1.InformacionLaboralParte2, { infolaboral: this.state.infolaboral, graduadoPost: this.state.graduadoPost, sectorList: sectorList, opcionesPrimerTrabajo: this.state.opcionesPrimerTrabajo, exceptionsInput: this.exceptionsInput, exceptionsTextInput: this.exceptionsTextInput, retrocederSeccion: this.retrocederSeccion, validarCambiosSeccion: this.validarCambiosSeccion })),
                            React.createElement("div", { id: "emprendimiento-section", style: { display: "none" } },
                                React.createElement(InformacionEmprendimiento_1.InformacionEmprendimiento, { infolaboral: this.state.infolaboral, graduadoPost: this.state.graduadoPost, sectorList: this.state.sectorListSelect, exceptionsInput: this.exceptionsInput, retrocederSeccion: this.retrocederSeccion, validarCambiosSeccion: this.validarCambiosSeccion })),
                            React.createElement("div", { id: "impacto-section", style: { display: "none" } },
                                React.createElement(InformacionImpacto_1.InformacionImpacto, { infolaboral: this.state.infolaboral, infoacademica: this.state.infoacademica, infoimpacto: this.state.infoimpacto, graduadoPost: this.state.graduadoPost, opcionesMejoraCondicion: this.state.opcionesMejorCondicion, retrocederSeccion: this.retrocederSeccion, validarCambiosSeccion: this.validarCambiosSeccion })),
                            React.createElement("div", { id: "academica-section", style: { display: "none" } },
                                React.createElement(InformacionAcademica_1.InformacionAcademica, { infoacademica: this.state.infoacademica, graduadoPost: this.state.graduadoPost, tieneDatosPost: this.state.tieneDatosPost, paisesList: paisesList, universidadList: universidadList, opcionesEstudios: this.state.opcionesEstudAdic, retrocederSeccion: this.retrocederSeccion, validarCambiosSeccion: this.validarCambiosSeccion })),
                            React.createElement("div", { id: "interes-section", style: { display: "none" } },
                                React.createElement(InformacionInteres_1.InformacionIntereses, { infoacademica: this.state.infoacademica, infolaboral: this.state.infolaboral, graduadoPost: this.state.graduadoPost, opcionesInteres: this.state.opcionesInteres, retrocederSeccion: this.retrocederSeccion, handleSubmit: this.handleSubmit }))),
                React.createElement("br", null),
                React.createElement("br", null)),
            React.createElement("div", { className: "col-sm-1" })));
    };
    return FormularioAlumni;
}(React.Component));
exports.FormularioAlumni = FormularioAlumni;
//# sourceMappingURL=FormularioAlumni.js.map